/* eslint-disable react/no-unescaped-entities */

import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

import AssetClassesHelperText from "./AssetClassesHelperText";

import styles from "./ListStyle.module.css";

const CreateNewPartner = () => {
  return (
    <ol className={styles.listStyle}>
      <li>
        <Text variant="bodySmall">In column A, enter the portfolio ID.</Text>
        <ol type="a" className={styles.listStyle}>
          <li>
            <Text variant="bodySmall">
              When creating a new portfolio, you'll have to come up with an ID
              to identify your portfolio in the future. The ID must start with
              "AIP_FAR_".
            </Text>
          </li>
          <li>
            <Text variant="bodySmall">
              The ID can contain letters, numbers, and underscores. Capitalize
              all letters.
            </Text>
          </li>
        </ol>
      </li>
      <li>
        <Text variant="bodySmall">
          In column B, enter the name of the model as you want it to appear in
          the portal.
        </Text>
      </li>
      <li>
        <Text variant="bodySmall">
          Column C should contain the "family_path" for the model. This controls
          how the model will be categorized in terms of Asset Management Firm,
          Model Series, and Asset Allocation.
        </Text>
        <ol type="a" className={styles.listStyle}>
          <li>
            <Text variant="bodySmall">
              Use a forward slash ("/") to separate the name of the asset
              manager, the category of model portfolios and asset allocation.
              Within the asset allocation, include a backslash ("\") between the
              equity and fixed income allocations.
            </Text>
          </li>
          <li>
            <Text variant="bodySmall">
              FAM models should begin with "FAM" (e.g., "FAM/Farther
              Core/60\/40").
            </Text>
          </li>
          <li>
            <Text variant="bodySmall">
              Farther Model Marketplace partners should begin with the name of
              the asset manager (e.g., "GrayRock/GrayRock Core/60\/40").
            </Text>
          </li>
        </ol>
      </li>
      <li>
        <Text variant="bodySmall">In column D, enter "Farther".</Text>
      </li>
      <li>
        <Text variant="bodySmall">
          Column E should contain the "base_permission" for the model—either
          "Private", "Public-Organization", or "Public-Platform". This controls
          who can view and apply the model.
        </Text>
        <ol type="a" className={styles.listStyle}>
          <li>
            <Text variant="bodySmall">
              "Private": Use this if the model portfolio should only be shared
              with specific advisors and their clients.
            </Text>
          </li>
          <li>
            <Text variant="bodySmall">
              "Public-Organization": Use this if you only want all Farther
              Advisors to get access.
            </Text>
          </li>
          <li>
            <Text variant="bodySmall">
              "Public-Platform": Use this if you want the model portfolio
              available to anyone on the Farther platform. Note that this will
              include other RIAs using Farther technology.
            </Text>
          </li>
        </ol>
      </li>
      <li>
        <Text variant="bodySmall">
          In column F, enter the ticker of a security. Leave this field blank if
          the row is for a sleeve.
        </Text>
        <ol type="a" className={styles.listStyle}>
          <li>
            <Text variant="bodySmall">
              Cash should be entered as "US Dollars".
            </Text>
          </li>
        </ol>
      </li>
      <li>
        <Text variant="bodySmall">
          In column G, if you want to include a different model as a sleeve
          within this model, enter the other model's portfolio_plan_id. Leave
          this field blank if the row is for a ticker.
        </Text>
      </li>
      <li>
        <Text variant="bodySmall">Leave column H blank.</Text>
      </li>
      <li>
        <Text variant="bodySmall">
          In column I, enter the weight of the holding. This must be a numerical
          value with two decimal places and a percentage sign (e.g. "1.00%").
          The model must sum to 100%.
        </Text>
      </li>
      <li>
        <Text variant="bodySmall">
          In column J, enter the tax status of the model. This can be "Taxable"
          or "Tax-exempt". Leave blank for a tax status of "Any".
        </Text>
      </li>
      <li>
        <Text variant="bodySmall">Leave column K blank.</Text>
      </li>
      <AssetClassesHelperText />
    </ol>
  );
};

export default CreateNewPartner;
